import { useEffect } from 'react';
import './App.css';
import { LOCAL_STORAGE_KEYS } from './constants/storage';
import { ClientConfig } from './libs/r2-service-client';
import AppRouter from './routes';

// ClientConfig 초기화 (토큰이 있으면 설정)
function setupClientConfig() {
  const token = localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
  const url = import.meta.env.VITE_FILE_API_BASE_URL;
  if (token) {
    ClientConfig.instance.setToken(token);
  }

  // 토큰 유무와 상관없이, 설정된 엔드포인트를 사용하도록 함
  ClientConfig.instance.setResourceEndpoint(url);
}

function App() {
  // Storage 초기화 및 ClientConfig 설정
  useEffect(() => {
    setupClientConfig();
  }, []);

  return <AppRouter />;
}

export default App;
